export default class DocutaxNotificationSetting {
  /**
   * @type {number}
   */
  id;

  /**
   * @type {number}
   */
  userId;

  /**
   * @type {boolean}
   */
  subscribeToResponses = false;

  /**
   * @type {boolean}
   */
  subscribeToAllSubmissions = false;

  /**
   * @type {boolean}
   */
  receiveTextNotification = false;

  /**
   * @type {boolean}
   */
  receiveEmailNotification = false;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.userId != null) {
        this.userId = opts.userId;
      }
      if (opts.subscribeToResponses != null) {
        this.subscribeToResponses = opts.subscribeToResponses;
      }
      if (opts.subscribeToAllSubmissions != null) {
        this.subscribeToAllSubmissions = opts.subscribeToAllSubmissions;
      }
      if (opts.receiveTextNotification != null) {
        this.receiveTextNotification = opts.receiveTextNotification;
      }
      if (opts.receiveEmailNotification != null) {
        this.receiveEmailNotification = opts.receiveEmailNotification;
      }
    }
  }
}
